import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { verifyVendor } from "./api";
import { Box, Button, Card, Grid } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import InputGroupShape from "../../../components/Inputs/InputGroupShape";
import SendIcon from "@mui/icons-material/Send";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { docsColumns } from "./columns";
import { lightTable } from "../../../styles/muiProps";

export default function VendorDocTransmittal() {
  const [data, setData] = useState({});
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      await verifyVendor(location.pathname.split("/")[3])
        .then((response) => {
          console.log("response", response);
          setData(response);
          console.log({ data });
        })
        .catch((error) => {
          console.log(error);
        });
    };
    verifyToken();
  }, []);

  const table = useMaterialReactTable({
    data: data?.documents || [],
    columns: docsColumns("portal"),
    ...lightTable,
  });

  return (
    <Box sx={{ m: "auto", mt: 5, width: 1000 }}>
      <InputGroupShape name="Document Transmittal Details">
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ p: 2, mt: 2 }}>
            <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
              Company:
            </span>
            <span>{data.companyName}</span>
          </Grid>

          <Grid item xs={6} sx={{ p: 2, mt: 2 }}>
            <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
              Document Transmittal Number:
            </span>
            <span>{data?.number}</span>
          </Grid>
          <Grid item xs={6} sx={{ p: 2 }}>
            <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
              Purpose:
            </span>
            <span>{data?.lifecycle}</span>
          </Grid>
          <Grid item xs={6} sx={{ p: 2 }}>
            <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
              Document Transmittal Rev:
            </span>
            <span>{data?.rev}</span>
          </Grid>
        </Grid>
      </InputGroupShape>
      {data.documents?.length && (
        <>
          <InputGroupShape
            name="Document Transmittal Documents"
            sx={{ display: "flex", mt: 4, p: 2, mx: 1 }}
          >
            <MaterialReactTable table={table} />

            {/* {data.documents.map((doc) => {
            return (
              <Box
                component="a"
                // target="_blank"
                href={
                  process.env.REACT_APP_STATIC +
                  "/api/download-docs/" +
                  doc.path
                }
                download
                sx={{ width: "300px", m: 1 }}
              >
                <Card
                  sx={{
                    cursor: "pointer",
                    p: 2,
                    m: 1,
                    width: "100%",
                  }}
                >
                  {doc.originalName}
                  <CloudDownloadIcon
                    sx={{
                      float: "right",
                      color: "primary.main",
                      transform: "translateY(-1px)",
                    }}
                  />
                </Card>
              </Box>
            );
          })} */}
          </InputGroupShape>
          <Box sx={{ textAlign: "right", px: 1 }}>
            <Button variant="contained" endIcon={<SendIcon />}>
              Send
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
